import { getLockDateWarningText } from 'modules/common/selectors/requestSelectors.QBooks';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import FieldsSection from '../../../components/FieldsSection';
import { messages } from './QBooksPurchaseOrderFields.messages';
import { QBooksPurchaseOrderFieldsProps } from './QBooksPurchaseOrderFields.types';

const qa = bemFactory.qa('reql-qbooks-request-card');

const QBooksPurchaseOrderFields: FC<QBooksPurchaseOrderFieldsProps> = memo((props) => {
    const { request } = props;
    const { details } = request;
    const lockDateWarningText = getLockDateWarningText(request);

    return (
        <FieldsSection>
            {details.mailingAddress && (
                <FieldsSection.Field
                    qa={qa('mailingAddress-field')}
                    title={messages.mailingAddressFieldTitle}
                    value={details.mailingAddress}
                />
            )}

            <FieldsSection.Field
                qa={qa('date-field')}
                title={messages.dateFieldTitle}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.date}
                warningText={lockDateWarningText}
            />

            <FieldsSection.Field
                qa={qa('number-field')}
                title={messages.numberFieldTitle}
                value={details.number || messages.emptyPurchaseOrderNumber}
            />

            {details.customFields.map((cf) =>
                cf.value ? (
                    <FieldsSection.Field
                        key={qa(`cf-${cf.field.id}-field`)}
                        qa={qa(`custom-field`)}
                        title={cf.field.text}
                        value={cf.value}
                    />
                ) : null
            )}
        </FieldsSection>
    );
});

export default QBooksPurchaseOrderFields;
